(function () {
  'use strict';

  var FIRST_ROW_COUNT = 4; // max images to eagerly load after filter (one row)

  function upgradeImages(grid) {
    var imgs = grid.querySelectorAll(
      '.product-grid-item__image-wrapper img, ' +
      '.product-grid-item__image-wrapper [data-src]'
    );
    var upgraded = 0;
    imgs.forEach(function (img) {
      if (upgraded >= FIRST_ROW_COUNT) return;
      // Swap data-src → src (hover images that landed in first row)
      if (img.dataset.src) {
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      }
      // Upgrade loading priority
      img.loading = 'eager';
      img.fetchPriority = 'high';
      upgraded++;
    });
  }

  function init() {
    var grid = document.querySelector('[data-products-grid]');
    if (!grid) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList' && mutations[i].addedNodes.length > 0) {
          upgradeImages(grid);
          break;
        }
      }
    });

    observer.observe(grid, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
